import $ from 'jquery';

var DrawView = {};
(function(){
    var winW = document.documentElement.clientWidth;
    console.log("1920");
    var _timer;
    var $html = $('html');
    DrawView.rem = (winW / 960 * 50).toFixed(4);
    if(window.location.search.indexOf("?type=750") !== -1){
        DrawView.rem = (winW / 375 * 50).toFixed(4);
    }
    $html.css('font-size', DrawView.rem + 'px');
    $(window).resize(function(){
        clearTimeout(_timer);
        _timer = setTimeout(function(){
            if(document.documentElement.clientWidth !== winW) {
                winW = document.documentElement.clientWidth;
                DrawView.rem = (winW / 960 * 50).toFixed(4);
                if(window.location.search.indexOf("?type=750") !== -1){
                    DrawView.rem = (winW / 375 * 50).toFixed(4);
                }
                $html.css('font-size', DrawView.rem + 'px');
            }
        },40);
    });
})();



// WEBPACK FOOTER //
// ./src/commonjs/fontSize.js